import { STATUS_OBJECT } from 'constants/index'

export default function getFormattedStatus(status: string) {
  return STATUS_OBJECT[status || 'DEFAULT']
}
